import { useRef, useState, useEffect } from 'react';
import classes from './personal-profile-form.module.scss';
import { IntlShape, useIntl } from 'react-intl';
import { Dialog, PasswordField } from '@marketplace/ui-elements';
import { resetPassowrdValidationSchema } from './reset-password-modal.validation';
import { joiResolver } from '@hookform/resolvers/joi';
import { useForm } from 'react-hook-form';
import {
  TAPIFetchDeveloper,
  TAPIPutDeveloperpassowrd,
} from '@marketplace/api';

type TPasswordProfileFormFields = Omit<
  TAPIFetchDeveloper['data'],
  'id' & 'email' & 'first_name'& 'last_name' & 'phone_number'>;

/* eslint-disable-next-line */
export interface ResetPasswordModalProps {
  isOpen : boolean
  password: string
  confirmPasssword: string
  setPassword: (value : string) => void
  setConfirmPassword: (value : string) => void
  onAccept : (password : string) => void
  onReject : () => void 
  children: React.ReactNode;
}

export const ResetPasswordModal = (
  props: ResetPasswordModalProps
): JSX.Element => {
  const { formatMessage }: IntlShape = useIntl();
  const formRef = useRef<HTMLFormElement>(null);
  const {control,reset,formState: { errors , isValid}} = useForm<TAPIPutDeveloperpassowrd>({
    mode: 'onChange',
    resolver: joiResolver(resetPassowrdValidationSchema({ formatMessage })),
  });

  const handlePasswordChange = (e : any) => {
    props.setPassword(e.target.value)
  }
  
  const handleConfirmPasswordChange = (e : any) => {
    props.setConfirmPassword(e.target.value)
  }

  const handleShow = () => {
    reset();
  }
  return (
    <Dialog 
      onShow={handleShow}
      visible={props.isOpen}
      header={ formatMessage({ id: 'developer_personal_page_personal_reset_password_header' })}
      acceptLabel={formatMessage({ id : 'developer_personal_page_personal_reset_password_set_new_password'})} 
      rejectLabel={formatMessage({ id : 'developer_personal_page_personal_reset_password_cancel'})}
      onAccept={() => props.onAccept(props.password)}
      onReject={props.onReject}
      isAcceptDisable={!isValid}
      >
        <form ref={formRef} >
          <div className={classes.popup}>
          <p className={classes.label}>Set a New Account Password</p>
          <p className={classes.description}>Please enter your new password twice to confirm it is correct.</p>
          <PasswordField
              isRequired
              control={control}
              onInput = {(e) => handlePasswordChange(e)}
              error={errors.password?.message}
              placeholder={formatMessage(
                { id: 'developer_personal_page_personal_reset_placeholder_New_Password' },
                { field: formatMessage({ id: 'registrationPassword_password' }) }
              )}
              rootClassName={classes.passwordField}
              inputClassName={classes.passwordInput}
              label={formatMessage({ id: 'developer_personal_page_personal_profile_password' })}
              fieldId="password"
              name="password"
              type="password"
              value={props.password}
            />
            <PasswordField
              isRequired
              control={control}
              error={errors.confirmPassword?.message}
              onInput = {(e) => handleConfirmPasswordChange(e)}
              placeholder={formatMessage(
                { id: 'developer_personal_page_personal_profile_confirmPassword' },
                { field: formatMessage({ id: 'registrationPassword_confirmPassword' }) }
              )}
              rootClassName={classes.confirmPasswordField}
              inputClassName={classes.passwordInput}
              label={formatMessage({ id: 'developer_personal_page_personal_reset_password_confirm_new_password' })}
              fieldId="confirmPassword"
              name="confirmPassword"
              type="password"
              value={props.confirmPasssword}
            />
          </div>
        </form>
    </Dialog>
  );
}
